export default __webpack_public_path__ + "static/media/640_dummy2016-ferienwohnung01-de.a1f9079f.png";